import { FC } from 'react';
// import { useMethods } from '@lhb/hook';
import styles from './index.module.less';
import cs from 'classnames';
import Block from '../Block';
import Card from '../Card';
import { Col, Row } from 'antd';

/**
 * 分析完成结果-踩点客流
 * @description
 * @demo
 */
const SpotFlow:FC<{}> = () => {

  return (<Block className={styles.spotFlow}>
    <div className={styles.titleRow}>
      <span className={styles.title}>踩点客流分析</span>
      <div className={styles.legends}>
        <div className={styles.legend}>
          <div className={styles.legendSquare} style={{ background: '#FAD173' }}></div>
          <div className={styles.legendName}>节假日客流</div>
        </div>
        <div className={cs(styles.legend, 'ml-16')}>
          <div className={styles.legendSquare} style={{ background: '#4B97FF' }}></div>
          <div className={styles.legendName}>工作日客流</div>
        </div>
      </div>
    </div>

    <div className={cs(styles.charts, 'mt-8')}>
      <div className={styles.top}>
        <img src={`${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/chancepoint/ai-predict-entry-rate/report-result/spotflow_linechart.png`} className={styles.linechart} />
      </div>

      <Row gutter={10} className={cs(styles.bottom, 'mt-12')}>
        <Col span={12}>
          <Card title='本门店踩点人群类型' className={styles.flowType}>
            <FlowTotalCard
              name='过店总人数'
              count='3429'
              unit='人'
              image={`${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/chancepoint/ai-predict-entry-rate/report-result/spotflow_total.png`}
            />
            <div className={cs(styles.genderRow, 'mt-10')}>
              <Row gutter={7}>
                <Col span={12}>
                  <FlowGenderCard
                    name='男性'
                    count='58.2%'
                    image={`${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/chancepoint/ai-predict-entry-rate/report-result/spotflow_male.png`}
                  />
                </Col>
                <Col span={12}>
                  <FlowGenderCard
                    name='女性'
                    count='41.8%'
                    image={`${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/chancepoint/ai-predict-entry-rate/report-result/spotflow_female.png`}
                  />
                </Col>
              </Row>
            </div>
          </Card>
        </Col>
        <Col span={12}>
          <Card title='本门店踩点年龄分布' className={styles.flowAge}>
            <div className={styles.imageWrapper}>
              <img src={`${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/chancepoint/ai-predict-entry-rate/report-result/spotflow_age.png`} />
            </div>
          </Card>
        </Col>
      </Row>

    </div>
  </Block>);
};


/**
 * @description 总人数统计卡片
 */
const FlowTotalCard: FC<{
  name: string;
  count: string;
  unit: string;
  image: string;
}> = ({
  name,
  count,
  unit,
  image,
}) => {
  return (
    <div className={cs(styles.innerCard, styles.totalCard)}>
      <div className={styles.totalLeft}>
        <span className='c-999 ft-14 mr-8'>{name}</span>
        <span className={styles.count}>{count}</span>
        <span className={styles.unit}>{unit}</span>
      </div>
      <div className={styles.totalRight}>
        <img src={image} className={styles.linechart} />
      </div>
    </div>
  );
};

/**
 * @description 性别统计卡片
 */
const FlowGenderCard: FC<{
  count: string;
  name: string;
  image: string;
}> = ({
  count,
  name,
  image,
}) => {
  return (
    <div className={cs(styles.innerCard, styles.genderCard)}>
      <div className={styles.genderLeft}>
        <div className={styles.count}>{count}</div>
        <div className={styles.name}>{name}</div>
      </div>
      <div className={styles.genderRight}>
        <img src={image} />
      </div>
    </div>
  );
};

export default SpotFlow;
